 <template>
  <div id="page-user-view">
    <action-container @changeView="(value) => currview(value)" />

    <main-info @changeView="(value) => currview(value)" />
    <details-info @changeView="(value) => currview(value)" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import actionContainer from "./actionContainer.vue";
import mainInfo from "./mainInfo.vue";
import detailsInfo from "./detailsInfo.vue";

import { settingsMixin } from "../settingsMixin";

export default {
  mixins: [settingsMixin],
  components: {
    actionContainer,
    mainInfo,
    detailsInfo
  },
  data() {
    return {};
  },
  methods: {
    currview(value) {
      console.log("value:", value);
      this.$emit(value.eventName, value.eventValue);
    }
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
